import React, { ReactElement, useState } from 'react';
import { ApolloError } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import { useUnarchiveWorkerMutation } from 'apollo/generated/client-operations';
import { AlertService } from 'components/alertService';
import { getGraphQLError } from 'utils/error';
import { UnarchiveWorkerModalProps } from './types';

export function UnarchiveWorkerModal({
  workerId,
  isOpen = false,
  closeModal,
  onConfirm,
}: UnarchiveWorkerModalProps): ReactElement {
  const [fetching, setFetching] = useState<boolean>(false);
  const [unarchiveWorkerMutation] = useUnarchiveWorkerMutation({
    onCompleted: () => {
      setFetching(false);
      closeModal();
      onConfirm?.();
      AlertService.alert(
        'success',
        'Worker successfully unarchived',
        'This worker has been unarchived',
      );
    },
    onError: (unarchiveError: ApolloError) => {
      setFetching(false);
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(unarchiveError),
      );
    },
  });

  const unarchiveWorker = (): void => {
    if (fetching) {
      return;
    }
    setFetching(true);
    unarchiveWorkerMutation({
      variables: {
        workerId,
      },
    });
  };

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      onCancel={closeModal}
      onAction={unarchiveWorker}
      size="xs"
      cancelText="Cancel"
      actionText="Unarchive"
      title="Are you sure?"
      actionButtonEnabled={!fetching}
    >
      <div>
        <h3>
          Are you sure you want to unarchive this worker? This will restore the
          worker and all of their nested records.
        </h3>
      </div>
    </Modal>
  );
}
